// src/modules/IntegratedMessaging/hooks/useIntegratedMessaging.ts

import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { IntegratedMessagingApiAdapter } from '../adapters/IntegratedMessagingApiAdapter';
import { IntegratedMessaging } from '../models/IntegratedMessaging';

export const useIntegratedMessaging = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new IntegratedMessagingApiAdapter(httpClient);

  return useQuery<IntegratedMessaging[]>({
    queryKey: ['courier-integrations'],
    queryFn: () => adapter.getCourierIntegrations(),
    staleTime: 5 * 60 * 1000,
  });
};
